// constants
import { showSuccessAlert } from "../../constants/alerts";
import { OrdersActionTypes } from "./constants";

const INIT_STATE = {
  orders: [],
  revenues: [],
  loading: false,
  initialLoading: false,
  error: null,
};

// interface newsData {
//   id: number;
//   title_en: string;
//   title_ar: string;
//   description_en: string;
//   description_ar: string;
//   images: File | null;
// }

interface orderActionType {
  type:
    | OrdersActionTypes.API_RESPONSE_SUCCESS
    | OrdersActionTypes.API_RESPONSE_ERROR
    | OrdersActionTypes.GET_ORDERS_REVENUE
    | OrdersActionTypes.GET_ORDERS;
  payload: {
    actionType?: string;
    data?: any;
    error?: string;
    orders?: [];
    revenues?: [];
  };
}

interface State {
  orders?: any;
  loading?: boolean;
  value?: boolean;
}

const Orders = (state: State = INIT_STATE, action: orderActionType): any => {
  switch (action.type) {
    case OrdersActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case OrdersActionTypes.GET_ORDERS: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            orders: action.payload.data,
          };
        }
        case OrdersActionTypes.GET_ORDERS_REVENUE: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            revenues: action.payload.data,
          };
        }

        default:
          return { ...state };
      }

    case OrdersActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case OrdersActionTypes.GET_ORDERS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case OrdersActionTypes.GET_ORDERS_REVENUE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }

        default:
          return { ...state };
      }

    case OrdersActionTypes.GET_ORDERS:
      return { ...state, loading: true, initialLoading: true };
    case OrdersActionTypes.GET_ORDERS_REVENUE:
      return { ...state, loading: true, initialLoading: true };

    default:
      return { ...state };
  }
};

export default Orders;
